import { useState, useEffect  } from "react";
const useWindowDimension = ({from}) => {
    const [dimension, setDimension] = useState([
      window.innerWidth,
      window.innerHeight,
    ]);
    const [height, setHeight] = useState([
      window.innerHeight,
    ]);

    useEffect(() => {
      const debouncedResizeHandler = debounce(() => {
        setDimension([window.innerWidth, window.innerHeight]);
        setHeight([window.innerHeight]);
      }, 100);
      if(from === 'office_bu'){
        window.addEventListener('resize', debouncedResizeHandler);
        return () => window.removeEventListener('resize', debouncedResizeHandler);
      }
    }, [from]);
    return height;
  }

  function debounce(fn, ms) {
    let timer;
    return _ => {
      clearTimeout(timer);
      timer = setTimeout(_ => {
        timer = null;
        fn.apply(this, arguments);
      }, ms);
    };
  }

  export default useWindowDimension;